import type {
  RequestCommentDomain,
  RequestCommentEntity
} from './request-comments.types'

export const RequestCommentMapper = {
  toEntity(domain: RequestCommentDomain): RequestCommentEntity {
    return {
      id: domain.id,
      message: domain.message,
      file: domain.file,
      createdAt: domain.createdAt,
      sentByClient: domain.sentByClient,
      isRead: domain.isRead,
      authorName: domain.authorName
    }
  }
}
